
// Define the Category interface
export interface Category {
  id: string;
  name: string;
  description: string;
  icon?: string;
  count?: number;
  image?: string;
}

// Define the categories array
export const categories: Category[] = [
  {
    id: "1",
    name: "Productivity",
    description: "Boost your workflow and get more done with less effort",
    count: 0,
    image: "/images/categories/productivity.jpg"
  },
  {
    id: "2",
    name: "Creative",
    description: "Unleash your creativity with powerful AI tools",
    count: 0,
    image: "/images/categories/creative.jpg"
  },
  {
    id: "3",
    name: "Business",
    description: "Optimize your business operations and strategy",
    count: 0,
    image: "/images/categories/business.jpg"
  },
  {
    id: "4",
    name: "Education",
    description: "Learn faster and teach better with AI assistance",
    count: 0,
    image: "/images/categories/education.jpg"
  },
  {
    id: "5",
    name: "Development",
    description: "Code smarter and faster with AI pair programming",
    count: 0,
    image: "/images/categories/development.jpg"
  },
  {
    id: "6",
    name: "Writing",
    description: "Craft compelling content with AI writing assistance",
    count: 0,
    image: "/images/categories/writing.jpg"
  },
  {
    id: "7",
    name: "Research",
    description: "Accelerate your research with intelligent tools",
    count: 0,
    image: "/images/categories/research.jpg"
  },
  {
    id: "8",
    name: "Data Analysis",
    description: "Extract insights from your data more effectively",
    count: 0,
    image: "/images/categories/data-analysis.jpg"
  },
  {
    id: "9",
    name: "Marketing",
    description: "Create and optimize marketing campaigns with AI",
    count: 0,
    image: "/images/categories/marketing.jpg"
  },
  {
    id: "10",
    name: "Design",
    description: "Enhance your design workflow with AI tools",
    count: 0,
    image: "/images/categories/design.jpg"
  },
  {
    id: "11",
    name: "Entertainment",
    description: "Have fun with AI-powered entertainment tools",
    count: 0,
    image: "/images/categories/entertainment.jpg"
  },
  {
    id: "12",
    name: "Health",
    description: "Improve health and wellness with AI assistance",
    count: 0,
    image: "/images/categories/health.jpg"
  }
];
